<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading" :can-cancel="true"> </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ title }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <label class="search-label">Driver Status</label>
                    <select
                      type="text"
                      placeholder=""
                      class="form-control ddown"
                      v-model="driver_status"
                    >
                      <option v-bind:value="-1">All</option>
                      <option v-bind:value="1">Active</option>
                      <option v-bind:value="2">Deactivated</option>
                      <option v-bind:value="3">Suspended</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <label class="search-label">Email</label>
                    <input
                      v-model="driver_email"
                      class="form-control"
                      placeholder="Email"
                      style="width: 100%"
                      type="text"
                      name="search_driver_search[email]"
                      id="search_driver_search_email"
                      maxlength="30"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <label class="search-label">First Name</label>
                    <input
                      v-model="driver_name_first"
                      class="form-control"
                      placeholder="First Name"
                      style="width: 100%"
                      type="text"
                      name="search_driver_search[firstname]"
                      id="search_driver_search_firstname"
                      maxlength="20"
                    />
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <label class="search-label">Last Name</label>
                    <input
                      v-model="driver_name_last"
                      class="form-control"
                      placeholder="Last Name"
                      style="width: 100%"
                      type="text"
                      name="search_driver_search[lastname]"
                      id="search_driver_search_lastname"
                      maxlength="20"
                    />
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 p-0">
                  <div class="m-2">
                    <label class="search-label">Select Vehicle Type</label>
                    <!-- <multiselect placeholder="Select vehicle type" :max-height="90"  v-model="selectedVehicleType" :options="vehicleOptions" label="name" track-by="name" :multiple="true" :taggable="true" @tag="addTag"></multiselect> -->
                    <div class="checkbox-item checkbox-form">
                      <ul class="checkbox-list">
                        <li
                          v-for="(options, index) in vehicleOptions"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            name="check"
                            :id="index"
                            :value="options.name"
                            v-model="selectedVehicleType"
                          />
                          <label :for="index">{{ options.name }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <label class="search-label">Market</label>
                    <select type="text" placeholder="Market" class="form-control ddown" id="market-filter" v-model="selected_market">
                      <option v-bind:value="'All'" >
                        All
                      </option>
                      <option v-for="market in markets" v-bind:value="market" v-bind:key="market.id_market">
                        {{ market.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 p-0">
                  <div class="m-2">
                    <input
                      type="checkbox"
                      v-model="isNoTripPast30Days"
                      id="no_trip_past_30_days_checkbox"
                      value=30
                    />
                    <label class="search-label" for="no_trip_past_30_days_checkbox">
                      No Trips Past 30 Days
                    </label>
                  </div>
                </div>
                <div class="col-12 p-0 submit-button">
                  <button
                    v-on:click="buttonSearch(currentPage)"
                    class="btn btn-info waves-effect waves-light m-t-10"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="result">
              <div class="table-responsive">
                <span>
                    <th>Page Size: </th>
                      <select
                        v-model="perPage"
                        class="form-control table-select"
                        @change="checkPageSize($event)"
                        style="width: 75px; margin-left: 15px;"
                      >
                        <option
                          v-for="size in page_sizes"
                          v-bind:key="size"
                          v-bind:value="size"
                        >
                          {{ size }}
                        </option>
                      </select>
                    </span>                  
                <table class="table table-hover table-sm">
                  <thead>
                  
                    <tr>
                      <th
                        class="result-label"
                        v-for="([column, sort_key], i) in data.resultColumns"
                        @click="sort(i)"
                      >
                        <div class="">
                          {{ column }}
                          <div
                            class="arrow-down"
                            ref="sort-arrow"
                            :name="sort_key"
                            :value="1"
                            style="visibility: hidden; margin-left: 5px"
                          ></div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="col-12">
                    <tr v-for="driver in data.sortedRides">
                      <td class="text-primary result-item">
                        <router-link :to="'/drivers/' + driver.id_user + '/'">
                          {{ driver.id_user }}
                        </router-link>
                      </td>
                      <td class="result-item">
                        {{ driver.email }}
                      </td>
                      <td class="result-item">
                        {{ driver.name_first }}
                      </td>
                      <td class="result-item">
                        {{ driver.name_last }}
                      </td>
                      <td class="result-item">
                        {{
                          driver.id_driver.id_type_driver_account
                            ? driver.id_driver.id_type_driver_account.code
                            : "N/A"
                        }}
                      </td>
                      <td class="result-item">
                        {{ driver.tags | driverTags }}
                      </td>
                      <td class="result-item">
                        {{ driver.id_driver.id_market.code }}
                      </td>
                      <td class="result-item">
                        {{ driver.location_county }}
                      </td>
                      <td class="result-item">
                        {{
                          !driver.vehicles || driver.vehicles.length == 0
                            ? "N/A"
                            : driver.vehicles[0].model
                        }}
                      </td>
                      <td class="result-item">
                        {{
                          !driver.vehicles || driver.vehicles.length == 0
                            ? "N/A"
                            : (driver.vehicles[0].id_type_vehicle
                                ? driver.vehicles[0].id_type_vehicle.code
                                : "id_type_vehicle missing") +
                              "(" +
                              (driver.vehicles[0].id_type_vehicle
                                ? driver.vehicles[0].id_type_vehicle.capacity
                                : "") +
                              ")"
                        }}
                      </td>
                      <td class="result-item">
                        {{
                          driver.app_info && driver.app_info.app_platform
                            ? driver.app_info.app_platform
                            : "N/A"
                        }}
                      </td>
                      <td class="result-item">
                        {{
                          driver.app_info && driver.app_info.app_version
                            ? driver.app_info.app_version
                            : "N/A"
                        }}
                      </td>
                      <td class="result-item">
                        {{ driver.id_driver.id_type_driver_status.name }}
                      </td>
                      <td class="result-item nowrap">
                        {{ driver.days_since_activated }}
                      </td>
                      <td class="result-item nowrap">
                        {{
                          driver.date_first_trip
                            ? moment(driver.date_first_trip).format("YYYY-MM-DD")
                            : "N/A"
                        }}
                      </td>
                      <td class="result-item">
                        {{ driver.num_trips }}
                      </td>
                      <td class="result-item">
                        {{ 
                          driver.days_since_last_trip == null
                            ? "N/A"
                            : driver.days_since_last_trip
                        }}
                      </td>
                      <!--<td class="result-item">-->
                      <!--{{ driver.id_referrer ? driver.id_referrer.name_first : 'N/A' }}-->
                      <!--</td>-->
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                style="
                  background-color: rgba(0, 0, 0, 0.05);
                  float: left;
                  width: 100%;
                "
              >
                <!-- <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div> -->

                <div
                  style="
                    background-color: rgba(0, 0, 0, 0.05);
                    float: left;
                    width: 100%;
                  "
                >
                  <div style="margin: 1rem 1rem; float: left">
                    <span v-if="totalRows > 0"
                      >Showing {{ perPage * (currentPage - 1) + 1 }} to
                      {{
                        perPage * currentPage > totalRows
                          ? totalRows
                          : perPage * currentPage
                      }}
                      of {{ totalRows }} entries</span
                    >
                    <span v-else>Showing 0 entries</span>
                  </div>

                  <div style="margin: 0 1rem; float: right">
                    <b-pagination
                      style="margin: 0.5rem 0"
                      align="center"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      :limit="limit"
                      @change="changePage"
                    >
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Multiselect from "vue-multiselect";

export default {
  metaInfo: {
    title: "Wingz Support | Driver Search",
  },
  name: "DriverSearch",
  data() {
    return {
      title: "Driver Search",
      page_sizes: [20, 50, 100, 500],      
      data: {
        rides: [],
        filteredRides: [],
        sortedRides: [],
        resultColumns: [
          ["ID", "id_user"],
          ["Email", "email"],
          ["First Name", "name_first"],
          ["Last Name", "name_last"],
          ["Driver Type", null],
          ["Vehicle Type", null],
          ["Market", "id_driver__id_market__code"],
          ["County", "location_county"],
          ["Vehicle", null],
          ["Vehicle Category", null],
          ["APP Platform", null],
          ["APP Version", null],
          ["Status", "id_driver__id_type_driver_status__name"],
          ["Days Since Activated", "created_at"],
          ["Date of First Trip", "date_first_trip"],
          ["Cumulative Trips", "num_trips"],
          ["Days Since Last Trip", "date_last_trip"],
        ],
        filters: {},
      },
      markets: null,
      selected_market: "All",
      driver_status: 1,
      isNoTripPast30Days: false,
      id_driver: null,
      driver_email: null,
      driver_name_first: null,
      driver_name_last: null,
      isLoading: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 50,
      limit: 10,
      prev_sort: null,
      with_deactivated: false,
      vehicleOptions: [
        {
          name: "Ambulatory",
        },
        {
          name: "Wheelchair",
        },
      ],
      selectedVehicleType: [],
    };
  },
  components: {
    Loading,
    Multiselect,
  },
  methods: {
    // multiselect handler
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    sort(index) {
      console.log(index);
      console.log(this.$refs)

      let obj = this.$refs['sort-arrow'][index];
      if (obj.getAttribute("name") == null) {
        return
      }

      console.log(obj);
      if (this.prev_sort) {
        this.prev_sort.style.visibility = "hidden";
      }

      let value = obj.getAttribute("value");
      console.log();
      obj.setAttribute("value", -value);
      console.log(obj.getAttribute("value"));

      obj.style.visibility = "visible";
      obj.style.transform = "rotate(" + (value > 0 ? 0 : 1) * 180 + "deg)";

      this.prev_sort = obj;

      this.search(this.currentPage);
    },
    checkPageSize: function (event) {
      this.search();
    },
    search: function (page) {
      let vehicleType = [];
      if (this.selectedVehicleType.length) {
        this.selectedVehicleType.forEach((element) => {
          vehicleType.push(element);
        });
      }

      this.isLoading = true;
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "drivers-search/?id_driver=" +
            (this.id_driver == null ? "" : this.id_driver) +
            "&email__icontains=" +
            (this.driver_email == null ? "" : this.driver_email) +
            "&name_first__icontains=" +
            (this.driver_name_first == null ? "" : this.driver_name_first) +
            "&name_last__icontains=" +
            (this.driver_name_last == null ? "" : this.driver_name_last) +
            "&id_driver__id_type_driver_status=" +
            (this.driver_status == -1 ? '' : this.driver_status) +
            "&vehicle_type=" +
            (vehicleType ? vehicleType : "") +
            "&id_driver__id_market=" +
            (this.selected_market == "All" ? '' : this.selected_market.id_market) +
            "&no_trip_past_days=" +
            (this.isNoTripPast30Days ? "30" : "") +
            "&ordering=" +
            (this.prev_sort
              ? (this.prev_sort.getAttribute("value") > 0 ? "" : "-") +
                this.prev_sort.getAttribute("name")
              : "") +
            "&page=" +
            (page ? page : this.currentPage) +
            "&tags=26&page_size=" +
            this.perPage
        )
        .then((response) => {
          this.data.rides = response.data.results;

          this.data.filteredRides = this.data.rides.slice(0);
          this.data.sortedRides = this.data.rides.slice(0);

          if (response.data && response.data.count) {
            this.totalRows = response.data.count;
          } else if (response.data && response.data.length) {
            this.totalRows = response.data.length;
          }
        })
        .catch((error) => {
          //console.log('error',error);
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.isLoading = false));
    },
    buttonSearch(page) {
      this.resetPager();
      this.search(page);
    },
    changePage: function (page) {
      this.search(page);
    },
    resetPager: function () {
      this.currentPage = 1;
      this.totalRows = 0;
    },
    getMarkets: function () {
      this.isLoading = true
      this.$http
        .get(process.env.API_BASE_URL_CS + 'markets/')
        .then(response => {
          this.markets = response.data
        })
        .catch(error => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login")
            this.handle401()
          }
          Vue.toasted.show('Something went wrong!', {
            theme: 'bubble',
            position: 'top-right',
            duration: 2000
          })
          console.log(error.response)
          this.errors = error.response.data
          this.non_field_errors = error.response.data.non_field_errors
        })
    },
  },
  mounted() {
    this.search();
    this.getMarkets();
  },
  created() {
    // document.title = "Wingz Support | Driver Search";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.submit-button {
  margin-top: 10px;
}

.result {
  margin-top: 20px;
}
.table th > div {
  position: relative;
  display: inline;
}
.table th > div .arrow-down {
  position: absolute;
  right: -13px;
  top: 40%;
}
</style>
<style>
.multiselect__tags {
  min-height: 40px !important;
  display: block !important;
  padding: 8px 40px 0 8px !important;
  border-radius: 0px;
  border: 0 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  background: #fff !important;
  font-size: 12px !important;
  margin-top: -11px !important;
}

.multiselect__option {
  font-size: 0.875rem;
}
.multiselect__input {
  font-size: 0.875rem;
}
.multiselect__placeholder {
  font-size: 0.875rem;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/SearchDrivers.vue